import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Button, Card, Container, Row, Col, Alert } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { createTaskInList } from '../services/api';

const NuovaAttivitaPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Ottieni l'ID della lista dalla location state
    const [listId] = useState(location.state?.listId || '');
    
    const [formData, setFormData] = useState({
        title: '',
        notes: '',
        due: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!location.state?.listId) {
            setError("ID della lista non specificato. Torna alla pagina delle attività e riprova.");
        }
    }, [location.state]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!formData.title) {
            setError('Il titolo è obbligatorio.');
            return;
        }
        if (!listId) {
            setError('ID della lista non valido. Impossibile creare l\'attività.');
            return;
        }

        const taskData = {
            title: formData.title,
            notes: formData.notes,
        };

        if (formData.due) {
            // L'API di Google Tasks vuole un timestamp RFC 3339.
            // Aggiungiamo l'orario per assicurare che la data sia interpretata correttamente in UTC.
            taskData.due = new Date(formData.due + 'T12:00:00Z').toISOString();
        }

        setLoading(true);
        try {
            await createTaskInList(listId, taskData);
            toast.success('Attività creata con successo!');
            navigate('/attivita');
        } catch (err) {
            console.error("Errore durante la creazione dell'attività:", err);
            setError('Si è verificato un errore durante la creazione dell\'attività.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card className="shadow-sm">
                        <Card.Header as="h5">Crea Nuova Attività</Card.Header>
                        <Card.Body>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label>Titolo Attività</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        required
                                        disabled={!listId}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="due">
                                    <Form.Label>Data di Scadenza (Opzionale)</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="due"
                                        value={formData.due}
                                        onChange={handleChange}
                                        disabled={!listId}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="notes">
                                    <Form.Label>Note (Opzionale)</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="notes"
                                        value={formData.notes}
                                        onChange={handleChange}
                                        disabled={!listId}
                                    />
                                </Form.Group>

                                <div className="d-flex justify-content-end">
                                    <Button variant="secondary" onClick={() => navigate('/attivita')} className="me-2">
                                        Annulla
                                    </Button>
                                    <Button variant="primary" type="submit" disabled={loading || !listId}>
                                        {loading ? 'Creazione...' : 'Crea Attività'}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default NuovaAttivitaPage;
